import o from "./ghl-ui.es1269.js";
var l = /(\$\d)/;
function u(n, a, t) {
  var r = t.useInternationalFormat, i = t.withNationalPrefix;
  t.carrierCode, t.metadata;
  var e = n.replace(new RegExp(a.pattern()), r ? a.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && a.nationalPrefixFormattingRule() ? a.format().replace(l, a.nationalPrefixFormattingRule()) : a.format()
  ));
  return r ? o(e) : e;
}
export {
  l as FIRST_GROUP_PATTERN,
  u as default
};
